export default __webpack_public_path__ + "static/media/G5.dc047ab0.mp3";